/**
 *
 * Copyright © 2026 Ping Identity Corporation. All right reserved.
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 *
 **/

import { z } from 'zod';

export const captchaConfigSchema = z
  .object({
    mode: z.enum(['visible', 'invisible']).optional(),
  })
  .strict();
